/* eslint-disable no-console */
import { updatePassword } from '../consumer-account/account-api';
import { setCookieValue } from '../consumer-account/authentication';
import { validate, validateByType } from '../../utils/form-validation-utils';

const completeRegistration = () => {
  const passwordMatch = (passIpt, passConfirmIpt) => {
    if (passIpt.value === passConfirmIpt.value) {
      return true;
    }
    return false;
  };

  const passwordStrength = (passIpt, passConfirmIpt) => {
    if (passIpt.value === '' && passConfirmIpt.value === '') {
      return true; // ignore
    }
    if (validateByType('password', passIpt.value) && validateByType('password', passConfirmIpt.value)) {
      return true;
    }
    return false;
  };

  const scrollToPageTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const clearSessionData = () => {
    const { sessionStorage } = window;
    sessionStorage.removeItem('bali_userId');
  };

  if (document.querySelector('.pr-complete-registration-form') === null) {
    return;
  }

  const form = document.querySelector('.pr-complete-registration-form');
  const submitBtn = form.querySelector('.o-form__submit');
  const passIpt = form.querySelector('[name="acctPassword"]');
  const passConfirmIpt = form.querySelector('[name="acctPasswordConfirm"]');
  const mismatchErrorMsg = form.querySelector('.password-mismatch-error-message');
  const existingErrorMsg = form.querySelector('.existing-account-error-message');
  const accountCreationErrorMsg = form.querySelector('.account-creation-error-message');
  const passwordStrengthErrorMsg = form.querySelector('.password-strength-error-message');

  submitBtn.addEventListener('click', (event) => {
    event.preventDefault();
    mismatchErrorMsg.classList.add('hide');
    existingErrorMsg.classList.add('hide');
    accountCreationErrorMsg.classList.add('hide');
    passwordStrengthErrorMsg.classList.add('hide');
    if (validate(form) && passwordMatch(passIpt, passConfirmIpt)) {
      // Get user id from session storage
      let userId = '';
      const { sessionStorage } = window;
      const sessionObj = sessionStorage.getItem('bali_userId');
      if (sessionObj !== null) {
        userId = JSON.parse(sessionObj).userId; /* eslint-disable-line prefer-destructuring */
      }
      updatePassword(
        {
          'user-id': userId,
          password: passIpt.value,
          'current-password': '',
        },
        {
          onSuccess: (data) => {
            if (data.success) {
              setCookieValue(userId);
              const { thankYouAuthenticatedLink } = window;
              clearSessionData();
              window.location = thankYouAuthenticatedLink;
            } else {
              accountCreationErrorMsg.classList.remove('hide');
            }
          },
          onError: (data) => {
            console.log(data);
            accountCreationErrorMsg.classList.remove('hide');
          },
        },
      );
    } else if (!passwordMatch(passIpt, passConfirmIpt)) {
      passIpt.parentNode.classList.add('ValidationFail');
      passConfirmIpt.parentNode.classList.add('ValidationFail');
      mismatchErrorMsg.classList.remove('hide');
      scrollToPageTop();
    } else {
      scrollToPageTop();
      if (!passwordStrength(passIpt, passConfirmIpt)) {
        passwordStrengthErrorMsg.classList.remove('hide');
      }
    }
  });
};
export default completeRegistration;
/* eslint-enable no-console */
